import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessThroat = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.1667 21.375V16.1542C19.3181 15.0875 20.1211 13.6984 20.4709 12.1683C20.8207 10.6382 20.7009 9.03813 20.1273 7.57712C19.5537 6.1161 18.5529 4.862 17.2555 3.97856C15.9582 3.09512 14.4246 2.6234 12.855 2.625C6.90585 2.625 5.62169 7.52334 3.50002 13.025C3.46369 13.1197 3.45092 13.2218 3.46282 13.3226C3.47471 13.4233 3.51092 13.5197 3.56832 13.6033C3.62572 13.6869 3.70259 13.7554 3.79231 13.8027C3.88203 13.85 3.98191 13.8748 4.08335 13.875H5.66669V16.375C5.66669 17.038 5.93008 17.6739 6.39892 18.1428C6.86776 18.6116 7.50365 18.875 8.16669 18.875H9.41669V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9167 19.8125C11.9996 19.8125 12.0791 19.8454 12.1377 19.904C12.1963 19.9626 12.2292 20.0421 12.2292 20.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.605 20.125C11.605 20.0421 11.6379 19.9626 11.6965 19.904C11.7551 19.8454 11.8346 19.8125 11.9175 19.8125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9167 20.4375C11.8339 20.4375 11.7544 20.4046 11.6958 20.346C11.6372 20.2874 11.6042 20.2079 11.6042 20.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.23 20.125C12.23 20.2079 12.1971 20.2874 12.1385 20.346C12.0798 20.4046 12.0004 20.4375 11.9175 20.4375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0425 19.1875C15.1254 19.1875 15.2048 19.2204 15.2635 19.279C15.3221 19.3376 15.355 19.4171 15.355 19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.73 19.5C14.73 19.4171 14.7629 19.3376 14.8215 19.279C14.8801 19.2204 14.9596 19.1875 15.0425 19.1875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0425 19.8125C14.9596 19.8125 14.8801 19.7796 14.8215 19.721C14.7629 19.6624 14.73 19.5829 14.73 19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.355 19.5C15.355 19.5829 15.3221 19.6624 15.2635 19.721C15.2048 19.7796 15.1254 19.8125 15.0425 19.8125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5425 16.6875C12.6254 16.6875 12.7048 16.7204 12.7635 16.779C12.8221 16.8376 12.855 16.9171 12.855 17"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.23 17C12.23 16.9171 12.2629 16.8376 12.3215 16.779C12.3801 16.7204 12.4596 16.6875 12.5425 16.6875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5425 17.3125C12.4596 17.3125 12.3801 17.2796 12.3215 17.221C12.2629 17.1624 12.23 17.0829 12.23 17"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.855 17C12.855 17.0829 12.8221 17.1624 12.7635 17.221C12.7048 17.2796 12.6254 17.3125 12.5425 17.3125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessThroat.displayName = 'SvgIllnessThroat';
export default SvgIllnessThroat;
